import { Fonts, TextAlignment } from '../../../backend/src/types/types';

export const FONT_FAMILY_OPTIONS = [
  { label: 'Times New Roman', value: Fonts.TimesNewRoman },
  { label: 'Arial', value: Fonts.Arial },
];

export const TEXT_ALIGNMENT_OPTIONS = [
  { label: 'Left Aligned', value: TextAlignment.Left },
  { label: 'Justified', value: TextAlignment.Both },
];
